/* eslint-disable no-unused-vars */
import ls from './localStorage'
import { env } from './config'
import { request, mountUrl, getLocalStorageWithExpiry, setLocalStorageWithExpiry, getLocaleParam } from './utils'
import { getCountryISO3 } from './countries'

import { getPermission } from '~/geoHelper'

import Cookies from '~/cookie'

const isAnonymous = Cookies.get('session-mode')?.toLowerCase().includes('anonimo')

function makeHash(prefix) {
  return `${prefix}-${Date.now()}-${Math.random() * 1000}`
}

function createLogger() {
  const fingerprint = ls.getItem('finger') || ls.setItem('finger', makeHash('finger'))
  let sessionId
  let position

  return {
    setPosition(newValue) {
      position = newValue
      sessionId = makeHash('session')
      // this.emit('sessionStart', { referrer: document.referrer, href: window.location.href })
    },

    emit(action, data) {
      data.brand = data.brand || window.appData.cnpj

      request(`${env.PREFIX}/logger`, {
        method: 'POST',
        body: { position, action, data, sessionId, fingerprint },
      })
    },

    getSessionId() {
      return 'teste-deletar'
      // return sessionId
    },
  }
}

export const logger = createLogger()

function filterDateLimit(item) {
  if (!item.limitDate) {
    return true
  }
  const [year, month, day] = item.limitDate.split('-').map((n) => parseInt(n))
  const limitDate = new Date(year, month - 1, day - 1, 23, 59)
  return limitDate > new Date()
}

function orderFeatured(products) {
  if (!products) return null
  if (!window.appData.featured) return products

  let listFeatured = []

  window.appData.featured
    .filter(filterDateLimit)
    .slice(0, 5)
    .forEach((item) => {
      const product = products.find((p) => p.gtin === item.gtin)

      if (product && listFeatured.length < 5) {
        listFeatured.push({ ...product, featured: item })
      }
    })

  listFeatured = listFeatured.sort((a, b) => (a.featured.order < b.featured.order ? -1 : 1))

  return listFeatured.concat(products.filter((p) => !listFeatured.find((f) => f.gtin === p.gtin)))
}

function compareLocations(a, b) {
  if (!a || !b) return false

  const aCountry = (a.countryCode || '').toUpperCase()
  const bCountry = (b.countryCode || '').toUpperCase()
  const aLang = (a.language || '').split('-')[0].toLowerCase()
  const bLang = (b.language || '').split('-')[0].toLowerCase()

  if (aCountry && bCountry) {
    if (aCountry !== bCountry) return false
    if (a.language && b.language) return aLang === bLang

    return true
  }

  if (!aCountry && !bCountry && a.language && b.language) {
    return aLang === bLang
  }

  return false
}

// factory
function createApi() {
  return {
    async getProducts(cnpj, userLocale = 'pt-BR') {
      const items = await request(`${env.PREFIX}/products2`, { params: { cnpj, userLocale } })
      return orderFeatured(items)
    },

    async getStores({ gtins, lng, ...params }) {
      const geoLocation = await getPermission()
      const sessionMode = Cookies.get('session-mode')
      const response = await request(`${env.PREFIX}/search-stores2/${gtins}`, {
        params: { ...params, lon: lng, geoLocation, sessionMode },
      })

      if (response.stores.length === 0) {
        throw new Error('empty_stores')
      }

      return response
    },

    // busca de produtos por termos (name)
    async search({ lat = 0, lng = 0, cnpj: brand = '', partner = '', name, gtin, locale = '' }) {
      let userLocale = locale || ''

      try {
        // 1. URL param (highest priority)
        if (!userLocale && typeof window !== 'undefined' && window.location && window.location.search) {
          const lp = getLocaleParam(window.location.search)
          if (lp && lp.locale) userLocale = lp.locale
        }

        // 2. widget.locale (portal)
        if (!userLocale && window?.appData?.locale) {
          userLocale = window.appData.locale
        }

        // 3. geolocation via IP - apenas se language não for pt-BR
        if (!userLocale && window?.appData?.language !== 'pt-BR') {
          const regionLocaleFromIP = await this.getLocationFromIP('gfnd.region:location')
          if (regionLocaleFromIP?.language) userLocale = regionLocaleFromIP.language
        }

        // 4. navigator.language
        if (!userLocale && typeof navigator !== 'undefined' && navigator.language) {
          userLocale = navigator.language
        }
      } catch (err) {
        console.warn('[search] locale resolution error', err)
      }

      const sessionMode = Cookies.get('session-mode')

      const params = {
        name: name ? encodeURI(name) : undefined,
        lat,
        lng,
        partner,
        brand,
        gtin,
        sessionMode,
        userLocale: userLocale || 'pt-BR',
      }

      const products = await request(`${env.PREFIX}/search-products2`, { params })

      return products
    },

    clickTrack({ event, ...data }) {
      if (isAnonymous) {
        return
      }
      return logger.emit(event, data)
    },

    getStoreDetails(cnpj) {
      return request(`${env.PREFIX}/store/${cnpj}/details`)
    },

    async getStoreProducts(cnpj) {
      let userLocale = ''

      try {
        // 1. URL param (highest priority)
        if (!userLocale && typeof window !== 'undefined' && window.location && window.location.search) {
          const lp = getLocaleParam(window.location.search)
          if (lp && lp.locale) userLocale = lp.locale
        }

        // 2. widget.locale (portal)
        if (!userLocale && window?.appData?.locale) {
          userLocale = window.appData.locale
        }

        // 3. geolocation via IP
        if (!userLocale && window?.appData?.language !== 'pt-BR') {
          const regionLocaleFromIP = await this.getLocationFromIP('gfnd.region:location')
          if (regionLocaleFromIP?.language) userLocale = regionLocaleFromIP.language
        }

        // 4. navigator.language
        if (!userLocale && typeof navigator !== 'undefined' && navigator.language) {
          userLocale = navigator.language
        }
      } catch (err) {
        console.warn('[getStoreProducts] locale resolution error', err)
      }

      // 5. default
      if (!userLocale) userLocale = 'pt-BR'

      return request(`${env.PREFIX}/store/${cnpj}/products`, {
        params: { userLocale },
      })
    },

    retailMessage(body) {
      return request(`${env.PREFIX}/retailermessage`, {
        method: 'POST',
        body,
      })
    },

    getLabel(
      {
        address: { label, houseNumber, street, district, city, state, county, postalCode },
        matchLevel,
        localityType,
        resultType,
      },
      getLiteral,
    ) {
      if (label) return label

      const type = matchLevel || localityType || resultType
      const province = state || county

      if (type === 'houseNumber')
        return `${street}, ${houseNumber}, ${district ? ` ${district} - ` : ''}${city} - ${province}`
      if (type === 'street') return `${street}, ${district ? ` ${district} - ` : ''}${city} - ${province}`
      if (type === 'district') return `${getLiteral('1284')}: ${district}, ${city} - ${province}`
      if (type === 'city') return `${getLiteral('1231')}: ${city} - ${province}`
      if (type === 'state' || type === 'county') return `${getLiteral('1443')}: ${province}`
      if (type === 'postalCode') return `${getLiteral('1444')}: ${postalCode}, ${city} - ${province}`
    },

    fetchGeoCode({
      address: { country, state, street = '', houseNumber = '', city = '', postalCode = '' },
      id,
      label,
      location = null,
    }) {
      let params, apiServiceName

      const { lat, lng } = location || { lat: 0, lng: 0 }

      if (id) {
        params = {
          apiKey: env.HERE_REST_APIKEY,
          id: encodeURI(id),
        }
        apiServiceName = 'lookup'
      } else {
        const s = (key, value) => (value ? `${key}=${value};` : '')

        params = {
          ...(lat && lng && { at: `${lat}%2C${lng}` }),
          apiKey: env.HERE_REST_APIKEY,
          show: 'countryInfo',
        }

        const qualifiedQuery = {
          country,
          state,
          street,
          houseNumber,
          city,
          postalCode,
        }

        const buildQueryString = Object.entries(qualifiedQuery)
          .map(([key, value]) => s(key, value))
          .join('')
          .slice(0, -1)

        label ? (params.q = encodeURI(label)) : (params.qq = encodeURI(buildQueryString))
        apiServiceName = 'geocode'
      }

      return request(mountUrl(`https://${apiServiceName}.search.hereapi.com/v1/${apiServiceName}`, params), {
        contentType: false,
      })
    },

    fetchGeoCodeGoogle(address) {
      return request(mountUrl(`${env.PREFIX}/geocode`, { address }), {
        contentType: false,
      })
    },

    fetchReverseGeocode({ lat, lng }) {
      const params = {
        at: `${lat}%2C${lng}`,
        lang: 'pt-BR',
        limit: 1,
        apiKey: env.HERE_REST_APIKEY,
      }
      return request(mountUrl('https://revgeocode.search.hereapi.com/v1/revgeocode', params), {
        contentType: false,
      })
    },

    // Ajustes: throttle de revalidação e sobrescrita do cache quando ipapi muda
    async getLocationFromIP(key, { verifyInterval = 1000 * 60 * 60 * 1 } = {}) {
      // verifyInterval: quanto tempo esperar entre revalidações (default 1h)
      const CACHE_TTL = 1000 * 60 * 60 * 24 // 24h
      const now = Date.now()

      const cachedLocation = getLocalStorageWithExpiry(key)

      // Decide se devemos verificar o ipapi (se não houver cache, ou última verificação é antiga)
      const lastVerified = cachedLocation?._lastVerifiedAt || 0
      const shouldVerify = !cachedLocation || now - lastVerified > verifyInterval

      // Se não precisamos verificar agora e temos cache: devolve cache imediatamente
      if (!shouldVerify && cachedLocation) {
        // console.debug('[geo] returning cached location', cachedLocation)
        return cachedLocation
      }

      // Caso contrário, consultamos o ipapi (note que this chamada será controlada pelo verifyInterval)
      try {
        const res = await fetch('https://ipapi.co/json/')
        if (!res.ok) {
          console.warn('[geo] ipapi responded non-OK', res.status)
          return cachedLocation || null
        }

        const data = await res.json()
        // --- DEBUG LIMPO E RELEVANTE ---
        console.debug('[geo] ipapi location info:', {
          city: data.city,
          region: data.region,
          country_name: data.country_name,
          country_code: data.country_code,
          country_code_iso3: data.country_code_iso3,
          timezone: data.timezone,
          languages: data.languages,
        })
        // --------------------------------

        const newLocation = {
          // preferimos iso3, se não existir usamos iso2 (mas NÃO forçamos BRA como fallback)
          countryCode: data.country_code_iso3 ?? data.country ?? null,
          // pegamos a primeira language da lista retornada
          language: data.languages ? data.languages.split(',')[0].trim() : null,
        }

        if (newLocation.countryCode) newLocation.countryCode = String(newLocation.countryCode).toUpperCase()
        if (newLocation.language) newLocation.language = String(newLocation.language).trim()

        // compara com o cache (ignorando TTL) — se for igual, apenas atualiza _lastVerifiedAt
        if (cachedLocation && compareLocations(cachedLocation, newLocation)) {
          const updated = { ...cachedLocation, _lastVerifiedAt: now }
          setLocalStorageWithExpiry(key, updated, CACHE_TTL)
          console.debug('[geo] ipapi returned same location → updated _lastVerifiedAt', updated)
          return updated
        }

        // se for diferente (ou não tinha cache), sobrescreve com as novas informações
        const toStore = { ...newLocation, _lastVerifiedAt: now }
        setLocalStorageWithExpiry(key, toStore, CACHE_TTL)
        console.debug('[geo] ipapi returned different/new location → overwrote cache', toStore)
        return { ...toStore }
      } catch (err) {
        return cachedLocation || null
      }
    },

    async searchLocation(input, config, position, location) {
      // We'll follow the strict priority order for locale determination:
      // 1. URL param (?locale=)
      // 2. Config locale (portal)
      // 3. Geolocation via IP (getLocationFromIP) - apenas se language não for pt-BR
      // 4. Browser geolocation (position.user)
      // 5. navigator.language
      // 6. default 'pt-BR'

      // read URL param first (highest priority)
      const localeParam = getLocaleParam(location.search)
      let finalLocale = null
      let finalCountryISO3 = null

      if (localeParam && localeParam.locale) {
        finalLocale = localeParam.locale
        finalCountryISO3 = localeParam.countryISO3 || null
      }

      // 2. config portal locale if none from URL
      if (!finalLocale && !finalCountryISO3 && config?.locale) {
        finalLocale = config.locale
        // try to get country ISO3 from config.locale if present and based on country ISO2
        const [, countryISO2] = config.locale.split('-')
        finalCountryISO3 = getCountryISO3(countryISO2) || null
      }

      // 3. geolocation via IP - apenas se language não for pt-BR
      let regionLocationByIP = null
      if ((!finalLocale || !finalCountryISO3) && window?.appData?.language !== 'pt-BR') {
        regionLocationByIP = await this.getLocationFromIP('gfnd.region:location')
      }

      if (!finalLocale && regionLocationByIP?.language) {
        finalLocale = regionLocationByIP.language
      }

      if (!finalCountryISO3 && regionLocationByIP?.countryCode) {
        // regionLocationByIP.countryCode may be ISO3 already; try to normalize
        finalCountryISO3 =
          regionLocationByIP.countryCode.length === 3
            ? regionLocationByIP.countryCode
            : getCountryISO3(regionLocationByIP.countryCode)
      }

      // 4. browser geolocation (position.user)
      if (!finalCountryISO3 && position?.user) {
        if (!finalCountryISO3 && position.user.countryCode) {
          finalCountryISO3 =
            position.user.countryCode.length === 3
              ? position.user.countryCode
              : getCountryISO3(position.user.countryCode)
        }
      }

      // 5. navigator.language
      if (!finalLocale && navigator && navigator.language) finalLocale = navigator.language

      // 6. default
      if (!finalLocale) finalLocale = 'pt-BR'

      // Prepare params for HERE API. HERE expects lang like 'en-US' and 'in=countryCode:XXX' where XXX is alpha-3
      const params = {
        q: encodeURIComponent(input),
        lang: finalLocale,
        apiKey: env.HERE_REST_APIKEY,
      }

      // resolve alpha-3 country code for HERE 'in' param
      if (finalCountryISO3) params.in = `countryCode:${finalCountryISO3}`

      return request(mountUrl('https://autocomplete.search.hereapi.com/v1/autocomplete', params), {
        contentType: false,
      }).then((res) => {
        return res.items ? res.items.filter((item) => Object.keys(item.address).includes('city')) : []
      })
    },

    reportProblem({ store, product, position, type, text }) {
      const body = {
        type,
        text,
        storeName: store.name,
        address: store.address,
        storeAddress: store.formattedAddress,
        productName: product.name,
        storeLocation: `${store.lat}, ${store.long}`,
        gtin: product.gtin,
        userLocation: `${position.lat},${position.lng}`,
        CNAE: store.CNAE,
        brand: store.brand,
        cnpj: store.cnpj,
        suppliers: store.suppliers,
        locatorExtraInfo: store.locatorExtraInfo,
      }

      return request(`${env.PREFIX}/report`, { method: 'POST', body })
    },

    ecommerce(gtin) {
      const params = {
        gtin,
      }

      return request(`${env.PREFIX}/ecommerce-list`, { method: 'GET', params })
    },

    async ecommerceGoogle(gtin, offerId, city, { widget = {}, location = {} }) {
      let userLocale = ''

      try {
        // 1. URL param (if location has search)
        if (!userLocale && location && location.search) {
          const lp = getLocaleParam(location.search)
          if (lp && lp.locale) userLocale = lp.locale
        }

        // 2. locale arg (config) has already been considered via `locale` param
        if (!userLocale && widget.locale) {
          userLocale = widget.locale
        }

        // 3. geolocation via IP - apenas se language não for pt-BR
        if (!userLocale && widget.language !== 'pt-BR') {
          const regionLocationByIP = await this.getLocationFromIP('gfnd.region:location')
          if (regionLocationByIP?.language) userLocale = regionLocationByIP.language
        }

        // 4. navigator.language
        if (!userLocale && typeof navigator !== 'undefined' && navigator.language) {
          userLocale = navigator.language
        }
      } catch (err) {
        // if any step fails, fall back gracefully
        console.warn('[ecommerceGoogle] locale resolution error', err)
      }

      if (!userLocale) userLocale = 'pt-BR'

      const params = {
        gtin,
        city,
        userLocale,
      }

      if (offerId) params.offerId = offerId

      return request(`${env.PREFIX}/ecommerce-google-list`, { method: 'GET', params })
    },

    ecommerceHistoryInsights(gtin, period) {
      const params = {
        gtin,
        period,
      }

      return request(`${env.PREFIX}/ecommerce-google-history`, { method: 'GET', params })
    },

    onlineStore() {
      return request(`${env.PREFIX}/online-store`, { method: 'GET' })
    },

    postAlertPrice(params) {
      return request(`${env.PREFIX}/online-store-email-price-alarms`, {
        method: 'POST',
        body: params,
      })
    },

    postWhatsappData(params) {
      return request(`${env.PREFIX}/form-whatsapp`, { method: 'POST', params })
    },

    gmbStore(cnpj) {
      const params = { cnpj }
      return request(`${env.PREFIX}/gmb-details`, { method: 'GET', params })
    },

    saveLogger({ lat, lon, gtin, cnpj }) {
      const params = {
        lat,
        lon,
        gtin,
        cnpj,
      }

      return request(`${env.PREFIX}/save-logger`, { method: 'GET', params })
    },
  }
}

export default createApi()
